var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4073 7.87597C28.4078 8.31248 27.3492 8.59869 26.266 8.72531C27.403 8.05762 28.258 6.99878 28.6713 5.74664C27.594 6.37375 26.419 6.81545 25.1953 7.05331C24.68 6.51358 24.0602 6.08449 23.3736 5.79221C22.6871 5.49993 21.9482 5.3506 21.202 5.35331C18.1806 5.35331 15.7313 7.76664 15.7313 10.74C15.7313 11.1613 15.7793 11.5733 15.8726 11.9666C13.7054 11.8636 11.5835 11.3099 9.6422 10.3408C7.70093 9.3718 5.98298 8.00875 4.59797 6.33864C4.11241 7.15784 3.85719 8.09302 3.85931 9.04531C3.86023 9.93593 4.08308 10.8123 4.50769 11.5952C4.93231 12.3781 5.54531 13.0428 6.29131 13.5293C5.42395 13.5013 4.57533 13.2697 3.81397 12.8533V12.92C3.81397 15.5306 5.70064 17.708 8.20064 18.204C7.73079 18.3286 7.24675 18.3918 6.76064 18.392C6.40731 18.392 6.06464 18.3586 5.72997 18.292C6.08742 19.3692 6.77145 20.3084 7.68706 20.9791C8.60268 21.6498 9.70443 22.0187 10.8393 22.0346C8.89273 23.534 6.50307 24.344 4.04597 24.3373C3.60331 24.3373 3.16864 24.3106 2.74064 24.2626C5.24898 25.8503 8.15743 26.691 11.126 26.6866C21.1886 26.6866 26.69 18.4773 26.69 11.3586L26.6713 10.6613C27.7444 9.9062 28.6715 8.96244 29.4073 7.87597Z",
    fill: "#F9F9F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.dd9100bc7f7d8982b8f83083ce87ab83.svg";
export { ForwardRef as ReactComponent };